export function getMatchListKey (match, index) {
  if (!match || typeof match !== 'object') return `match-${index}`
  const id = match.id || match.match_id || match.schedule_id || match.fix_id
  if (id !== undefined && id !== null && id !== '') return String(id)
  return [
    match.date_time || match.date || '',
    match.host_team_id || match.host_team_name || '',
    match.guest_team_id || match.guest_team_name || '',
    index
  ].join('-')
}
